var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useReducer, useState } from 'react';
import { ChatPanels } from '../../../types';
import { ChatHeader } from '../../ChatHeader';
import MessageList from '../MessageList';
import { SignIn } from '../SignIn';
import { SmartChatTypes, authReducer, initialAuthState, initialSmartChatState, smartChatReducer, } from '../SmartChat/states';
import { SmartExperimentCheckpoint } from '../SmartChat/states/state/types';
import { GUEST_IDENTITY, createBotMessage, sleep } from '../SmartChat/utils';
import { MessageListWrapper } from '../style';
import { Verify } from '../Verify';
import { Header } from './Header';
import { sendMessageWithTypingDecorator } from '../SmartChat/decorators';
import { PHONE_VALIDATION_SUCCESS_MESSAGE_1, PRIVACY_POLICY_MESSAGE } from '../SmartChat/Constants';
export var SmartChatExperiment1 = function () {
    var _a = useReducer(smartChatReducer, __assign(__assign({}, initialSmartChatState), { messages: [] })), chatState = _a[0], chatDispatch = _a[1];
    var _b = useReducer(authReducer, initialAuthState), authState = _b[0], authDispatch = _b[1];
    var _c = useState(false), showVerify = _c[0], setShowVerify = _c[1];
    var members = chatState.members, messages = chatState.messages, experimentCheckpoint = chatState.experimentCheckpoint;
    var displayRefTheOther = React.useRef(null);
    var experimentStateHandler = function () {
        setShowVerify(false);
        chatDispatch({ type: SmartChatTypes.RESET_MESSAGE });
    };
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(experimentCheckpoint === SmartExperimentCheckpoint.ON_VERIFY_CHECK)) return [3 /*break*/, 2];
                        return [4 /*yield*/, sendMessageWithTypingDecorator(chatDispatch, PRIVACY_POLICY_MESSAGE, messages.length + 1)];
                    case 1:
                        _a.sent();
                        chatDispatch({
                            type: SmartChatTypes.NEXT_EXPERIMENT_ONE_SMART_STATE,
                            payload: SmartExperimentCheckpoint.ON_VERIFY_CHECK,
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        if (experimentCheckpoint === SmartExperimentCheckpoint.ON_SIGN_IN_CHECK) {
                            chatDispatch({
                                type: SmartChatTypes.CLEAR_MESSAGE,
                                payload: createBotMessage(PHONE_VALIDATION_SUCCESS_MESSAGE_1, 1),
                            });
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    }, [experimentCheckpoint]);
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(messages.length >= 2)) return [3 /*break*/, 2];
                        return [4 /*yield*/, sleep(1000)];
                    case 1:
                        _a.sent();
                        setShowVerify(true);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); })();
    }, [messages]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ChatHeader, { activePanel: ChatPanels.Default, showBackArrow: true }),
        React.createElement(Header, null),
        React.createElement(MessageListWrapper, null,
            experimentCheckpoint === SmartExperimentCheckpoint.ON_SIGN_IN_CHECK && (React.createElement(SignIn, { chatState: chatState, chatDispatch: chatDispatch, authState: authState, authDispatch: authDispatch, showEmail: true, experiment1: true })),
            experimentCheckpoint === SmartExperimentCheckpoint.ON_VERIFY_CHECK && (React.createElement(React.Fragment, null,
                React.createElement(MessageList, { identity: GUEST_IDENTITY, members: members, messages: messages, userType: 'customer', isExperiment: true }),
                showVerify && (React.createElement(Verify, { chatState: chatState, chatDispatch: chatDispatch, authState: authState, authDispatch: authDispatch, experimentStateHandler: experimentStateHandler, experiment1: true })))),
            React.createElement("div", { ref: displayRefTheOther }))));
};
//# sourceMappingURL=index.js.map